import { render } from "./AppPalette.vue?vue&type=template&id=4542eb9a&scoped=true&ts=true"
import script from "./AppPalette.vue?vue&type=script&lang=ts"
export * from "./AppPalette.vue?vue&type=script&lang=ts"

import "./AppPalette.vue?vue&type=style&index=0&id=4542eb9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4542eb9a"]])

export default __exports__